import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Private mode is a client-side gate unlocked with a PIN. When ON, the API client
 * sends the `X-Private-Mode` header and the backend reveals private series, their
 * images and history, and "er_"-prefixed permutation lists. When OFF, all of that
 * is hidden everywhere.
 *
 * The state is read outside React (in the API client) via `usePrivateMode.getState()`,
 * so the store doubles as a plain global.
 */

export const PRIVATE_MODE_PIN = '3333';

interface PrivateModeState {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

export const usePrivateMode = create<PrivateModeState>()(
  persist(
    (set) => ({
      enabled: false,
      setEnabled: (enabled: boolean) => set({ enabled }),
    }),
    {
      name: 'comfy-private-mode',
      storage: createJSONStorage(() =>
        typeof window !== 'undefined' ? window.localStorage : undefined as unknown as Storage
      ),
    }
  )
);

/** Whether private mode is currently unlocked (safe to call anywhere, incl. SSR). */
export function isPrivateModeEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  return usePrivateMode.getState().enabled;
}
